// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import TranslatedOption from '../../../shared/components/translated-option';

const DemoRentalProductRegCriteria = props =>
    <div className='demo-rental-product-reg-criteria'>
        <h3>
            <FormattedMessage id={props.label}/>
        </h3>
        <select
            onChange={props.onProductRegistered}
            value={props.productRegistered}
        >
            <TranslatedOption
                text='YES'
                value='YES'
            />
            <TranslatedOption
                text='NO'
                value='NO'
            />
        </select>
    </div>;

DemoRentalProductRegCriteria.displayName = 'DemoRentalProductRegCriteria';
DemoRentalProductRegCriteria.propTypes = {
    label: PropTypes.string.isRequired,
    onProductRegistered: PropTypes.func.isRequired,
    productRegistered: PropTypes.string.isRequired
};

export default DemoRentalProductRegCriteria;



// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/components/demo-rental-product-reg-criteria.js